<template>
  <div class="login-back">
    <div class="login-content">
      <div class="input-info">
        <div style="margin-top:20px;font-size: 30px;color: blue">办公OA系统</div>
        <div style="margin-top:20px;font-size: 25px">欢迎登录</div>
        <div style="margin-top:50px;">
          <el-input style="width:300px" v-model.trim="name" placeholder="请输入用户名">
           <template slot="prepend">账号</template>
          </el-input>
        </div>
        <div style="margin-top:30px;">
          <el-input style="width:300px" type="password" v-model.trim="password" placeholder="请输入密码" @keyup.enter.native="submitlogin">
            <template slot="prepend">密码</template>
          </el-input>
        </div>
        <div style="margin-top:50px;">
          <el-button style="width:300px" type="primary" v-on:click="submitlogin">登录</el-button>
        </div>

      </div>
    </div>
      <div style="color:rgba(24,24,24,0.82);text-align: center;
      position:absolute; bottom:10px;margin: 0 auto;width:100%;color: #E8E8E8">
          <footer_text/>
      </div>
  </div>
</template>
<style scoped>
.login-back {
  background: url(../assets/icon/landing.jpg) no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
  height: 100%;
  width: 100%;
  position: absolute;
}

.input-info {
  width: 400px;
  height: 400px;
  padding: 20px;
  text-align: center;
  position: absolute;
  left: 67%;
  top: 50%;
  margin-left: -200px;
  margin-top: -200px;
  border-radius: 10px;
}
span {
  margin-left: 20px;
}
</style>


<script>
import footer_text from "./footer_text";
import { encryptPassword } from '../assets/js/crypto';
export default {
  name: "login",
  data: function() {
    return {
      name: "",
      password: ""
    };
  },
  components: {
    footer_text
  },
  methods: {
    submitlogin: function() {
      if (this.name == "") {
        this.$message({ message: "账号不能为空", type: "warning" });
        return;
      }
      if (this.password == "") {
        this.$message({ message: "密码不能为空", type: "warning" });
        return;
      }
      const that = this;
      const encryptedPwd = encryptPassword(this.password); 
      this.axios
        .post("api/uaa/user/login/byPassword", {
          loginAccount: this.name,
          loginPassword: `04${encryptedPwd}`
        })
        .then(function(response) {
          let rData = response.data;
          if (rData.code != "00000") {
            that.$message({ message: rData.msg, type: "warning" });
            return;
          }
          let userModel = rData.model;
          //封装用户信息。
          let userInfo = {};
          userInfo.token = userModel.token;
          userInfo.user = {
            userName: userModel.userName,
            userId: userModel.userInfo.model.user_id,
            staffId:userModel.userInfo.model.staff_id,
          };
          userInfo.elementsMap = {};
          for (let i = 0; i < userModel.elementIds.length; i++) {
            userInfo.elementsMap["e_" + userModel.elementIds[i]] = 1;
          }
          userInfo.menus = userModel.menus;
          that.$store.commit("setUserInfo", userInfo);
          sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
          that.$router.push("/index");
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/login.vue